import { render, staticRenderFns } from "./SourceSearchBox.vue?vue&type=template&id=aa6c8f8a"
import script from "./SourceSearchBox.vue?vue&type=script&lang=js"
export * from "./SourceSearchBox.vue?vue&type=script&lang=js"
import style0 from "./SourceSearchBox.vue?vue&type=style&index=0&id=aa6c8f8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports